import { CheckOutlined, CrownFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'templates/Button';

import {
  PromoModal,
  PromoModalContent,
  PromoModalTitle,
} from './styles';
import { SPORT_VOKRUG_PLUS_PROMO_TRANSLATION_NAMESPACE } from './translations';

const SportVokrugPlusPromoModal = ({
  is_open,
  is_plan_available,
  on_after_open_change,
  on_choose_plan,
  on_close,
}) => {
  const { t } = useTranslation(SPORT_VOKRUG_PLUS_PROMO_TRANSLATION_NAMESPACE);

  return (
    <PromoModal
      centered
      destroyOnHidden
      footer={null}
      open={is_open}
      width={540}
      afterOpenChange={on_after_open_change}
      onCancel={on_close}
      title={(
        <PromoModalTitle>
          <CrownFilled />
          {t('button')}
        </PromoModalTitle>
      )}
    >
      <PromoModalContent>
        <strong>{t('eyebrow')}</strong>
        <h2>{t('title')}</h2>
        <p>{t('description')}</p>

        <ul>
          <li>
            <span><CheckOutlined /></span>
            <span>{t('benefitCategories')}</span>
          </li>
          <li>
            <span><CheckOutlined /></span>
            <span>{t('benefitNews')}</span>
          </li>
          <li>
            <span><CheckOutlined /></span>
            <span>{t('benefitFutureFeatures')}</span>
          </li>
        </ul>

        <Button
          primary
          stretch
          disabled={!is_plan_available}
          onClick={on_choose_plan}
          data-testid="sport-vokrug-plus-choose-plan-button"
        >
          {t('choosePlan')}
        </Button>

        <small>{t('footerNote')}</small>
      </PromoModalContent>
    </PromoModal>
  );
};

SportVokrugPlusPromoModal.propTypes = {
  is_open: PropTypes.bool.isRequired,
  is_plan_available: PropTypes.bool.isRequired,
  on_after_open_change: PropTypes.func.isRequired,
  on_choose_plan: PropTypes.func.isRequired,
  on_close: PropTypes.func.isRequired,
};

export default SportVokrugPlusPromoModal;
